var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "icon-font-wrapper",
        [
          _c(
            "header",
            { staticClass: "sb-topbar" },
            [
              _c(
                "a",
                {
                  staticClass: "sb-topbar-logo",
                  attrs: { href: "" + _vm.SbBaseUrl }
                },
                [
                  _vm._v("SPHERE"),
                  _c("span", { staticClass: "sb-logo-accent" }, [
                    _vm._v("board")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sb-topbar-divider" }),
              _vm._v(" "),
              _c("span", { staticClass: "sb-topbar-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$route.meta.title))]),
                _vm._v(" "),
                !!_vm.subHeadingText
                  ? _c("span", [_vm._v(" : " + _vm._s(_vm.subHeadingText))])
                  : !!_vm.$route.meta.subHeader
                  ? _c("span", [
                      _vm._v(
                        "\n          : " +
                          _vm._s(_vm.$route.meta.subHeader) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sb-topbar-spacer" }),
              _vm._v(" "),
              _c("global-search-control", {
                on: { assetselected: _vm.getSelectedAsset }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "sb-topbar-icon-btn",
                  attrs: {
                    id: "user-guide",
                    href:
                      "https://docs.sphereco.com/sphereboard-" +
                      _vm.quickHelpVersion +
                      "-user-guides",
                    target: "_blank",
                    title: "Open the user guide"
                  }
                },
                [
                  _c("span", { staticClass: "material-icons-outlined" }, [
                    _vm._v("help_outline")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "sb-topbar-icon-btn",
                  attrs: {
                    id: "request-support",
                    href: "https://customer.sphereco.com/",
                    target: "_blank",
                    title: "Request Support"
                  }
                },
                [
                  _c("span", { staticClass: "material-icons-outlined" }, [
                    _vm._v("support_agent")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sb-topbar-user" }, [
                _c(
                  "button",
                  {
                    staticClass: "sb-user-btn",
                    attrs: {
                      "data-cy": "sb-user-btn",
                      "aria-haspopup": "true",
                      "aria-expanded": _vm.isExpanded.toString()
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.isExpanded = !_vm.isExpanded
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        _vm.isExpanded = false
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { id: "currentUser" } }, [
                      _vm._v(_vm._s(_vm.currentUser))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "material-icons-outlined" }, [
                      _vm._v(
                        _vm._s(_vm.isExpanded ? "expand_less" : "expand_more")
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isExpanded,
                        expression: "isExpanded"
                      }
                    ],
                    staticClass: "sb-user-dropdown",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        _vm.isExpanded = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "sb-dd-header" }, [
                      _c("div", { staticClass: "sb-dd-name" }, [
                        _vm._v(_vm._s(_vm.currentUser))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sb-dd-role" }, [
                        _vm._v(_vm._s(_vm.userRole))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sb-dd-row" }, [
                      _c("span", [_vm._v("Theme")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sb-theme-group" }, [
                        _c(
                          "button",
                          {
                            class: [
                              "sb-theme-btn",
                              _vm.themeMode === "light" ? "active" : ""
                            ],
                            on: {
                              click: function($event) {
                                return _vm.setTheme("light")
                              }
                            }
                          },
                          [_vm._v("\n                Light\n              ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            class: [
                              "sb-theme-btn",
                              _vm.themeMode === "dark" ? "active" : ""
                            ],
                            on: {
                              click: function($event) {
                                return _vm.setTheme("dark")
                              }
                            }
                          },
                          [_vm._v("\n                Dark\n              ")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showLogout
                      ? _c(
                          "div",
                          {
                            staticClass: "sb-dd-signout",
                            attrs: { "data-cy": "sb-logout-btn" },
                            on: { click: _vm.logout }
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"
                                  }
                                }),
                                _vm._v(" "),
                                _c("polyline", {
                                  attrs: { points: "16 17 21 12 16 7" }
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "21",
                                    y1: "12",
                                    x2: "9",
                                    y2: "12"
                                  }
                                })
                              ]
                            ),
                            _vm._v("\n            Sign out\n          ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "sb-dd-version" }, [
                      _vm._v(_vm._s(_vm.sbVersion))
                    ])
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideSidebar
            ? _c("main-layout-sidebar", { ref: "sidebar" })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayLicenseWarning ? _c("license-alert") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-content",
            [
              _c(
                "v-container",
                {
                  class: ["IdentityMap", "AccountInstances"].includes(
                    _vm.$route.name
                  )
                    ? "pa-0"
                    : "pa-2",
                  attrs: { fluid: "" }
                },
                [
                  _c("the-offline-alert"),
                  _vm._v(" "),
                  _c("status-display-bar", {
                    attrs: { error: _vm.errorMessage }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      attrs: { "max-width": "500px", persistent: "" },
                      model: {
                        value: _vm.showIdleAlert,
                        callback: function($$v) {
                          _vm.showIdleAlert = $$v
                        },
                        expression: "showIdleAlert"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-flex", [
                                    _vm._v(
                                      "\n                  Session has been idle for " +
                                        _vm._s(_vm.appIdleAlertTime) +
                                        " minutes.\n                  Please click on OK to continue.\n                "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "sb_btn_solid",
                                    attrs: { color: "success" },
                                    on: { click: _vm.closeIdleWarning }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  OK\n                "
                                    )
                                  ]
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { class: _vm.wrapperClass }, [_c("router-view")], 1)
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }